// extracted by mini-css-extract-plugin
export default {"base":"ColumnChartDisplay_base__JXpbs","select":"ColumnChartDisplay_select__ame1d"};